import apiClient from "./axios.config";

const customerInfoServices = {
  getProfileInfo() {
    return apiClient.get("owners/profile/basic");
  },

  updateProfileInfo(formData) {
    return apiClient.put("owners/profile/basic", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getVendorProfileInfo() {
    return apiClient.get("vendors/profile/basic");
  },

  updateVendorProfileInfo(formData) {
    return apiClient.put("vendors/profile/basic", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default customerInfoServices;
